import { render, staticRenderFns } from "./cascaderAll.vue?vue&type=template&id=3821f5ba"
import script from "./cascaderAll.vue?vue&type=script&lang=js"
export * from "./cascaderAll.vue?vue&type=script&lang=js"
import style0 from "./cascaderAll.vue?vue&type=style&index=0&id=3821f5ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports